import BaseListPresenter from "../../../base/BaseListPresenter";
import { dialog, Button } from "nq-component";

class DisbursementsPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    this.limit = 10;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  dialogClose() {
    dialog.close();
  }

  async getHandleDelete(data) {
    dialog.fire({
      html: (
        <div>
          <div className="row p-2 " style={{ textAlign: "center" }}>
            <p>
              <i
                className="bi bi-question-circle"
                style={{ color: "orange", fontSize: "20px" }}
              ></i>{" "}
              "Are You Sure You want to Delete this Disbursement?"
              <div className="mt-1">
                <b></b>
              </div>
            </p>
            <p
              style={{
                fontSize: "13px",
                color: "rgba(0, 0, 0, .65)",
              }}
            >
              Please click on OK to confirm changes.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-3 pe-3 pb-3">
            <Button className="btn btn-light fs-sm" onClick={this.dialogClose}>
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => this.confirmChanges(data)}
            >
              OK
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  async confirmChanges(data) {
    const { id } = data;
    await this.deleteObjectUseCase.execute("disbursement", id);
    this.view.refetchData();
    this.dialogClose();
  }
}
export default DisbursementsPresenter;
